import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ij2qgczobo: FaireBrandEntity = {
  token: "b_ij2qgczobo",
  type: "brand",
  name: "Boulevard",
  avatarUrl:
    "https://cdn.faire.com/fastly/1f2a51f1cb283eaae1aec95549d24d551e1a9e89ec5ff93a94114a9932e5f43d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ad273995b288104750d94723760145f7f394ae73d4656d5591a0ddabd7d9137a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1f2a51f1cb283eaae1aec95549d24d551e1a9e89ec5ff93a94114a9932e5f43d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ad273995b288104750d94723760145f7f394ae73d4656d5591a0ddabd7d9137a.jpeg",
  location: "Fullerton, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 54,
  isTopShop: true,
  isInsider: true,
  description:
    "Boulevard is an accessory line started by California native, Christina Oh.  Christina has been developing her line for over 20 years and what started as a leather stationary line now encompasses a wide array of goods- all with the common theme of better design. The Boulevard line is about exceptional workmanship, quality materials and most of all, functionality.  Check out our website blvdca.com and follow us on instagram @boulevard.ca\nReach out to us if you are interested in seeing more personalization options (We also do custom logos on our products!)",
  meta: {
    source: "api",
    importedAt: "2026-07-17T19:04:04.137Z",
    importedBy: "entity-db-cli",
  },
};
